var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallPlusDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A869A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 1.05c-.565-.565-1.481-.565-2.047 0L10.15 8.103 3.096 1.05c-.565-.565-1.481-.565-2.046 0-.565.565-.565 1.481 0 2.046l7.053 7.054-7.053 7.053c-.565.566-.565 1.482 0 2.047.565.565 1.481.565 2.046 0l7.054-7.054 7.053 7.054c.566.565 1.482.565 2.047 0 .565-.565.565-1.481 0-2.047l-7.054-7.053 7.054-7.054c.565-.565.565-1.481 0-2.046z",
    transform: "rotate(45 6.464 18.536)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallPlusDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-plus-default.34a2cdeff97a73979f771059193573f8.svg";